import { Tabs } from 'antd';
import type { ButtonProps } from 'antd/lib/button';
import React, { type FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Form from '../../../components/fields/Form';
import FormAutoTouch from '../../../components/FormAutoTouch';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import FinanceProductForm, { Tab, useTabs } from '../FinanceProductDetailsPage/FinanceProductForm';

type InnerProps = {
    handleSubmit: (e?: React.FormEvent<HTMLFormElement>) => void;
    loadingButton: FC<ButtonProps>;
};

const Inner = ({ handleSubmit, loadingButton: LoadingButton }: InnerProps) => {
    const { t } = useTranslation(['financeProductDetails']);
    const navigate = useNavigate();

    const [activeTab, setActiveTab] = useState<string>(Tab.MainDetails);

    const tabs = useTabs();

    return (
        <ConsolePageWithHeader
            footer={[
                <LoadingButton key="submit" form="financeProductForm" htmlType="submit" type="primary">
                    {t('financeProductDetails:actions.create')}
                </LoadingButton>,
            ]}
            header={{
                footer: (
                    <Tabs activeKey={activeTab} onChange={setActiveTab}>
                        {tabs}
                    </Tabs>
                ),
            }}
            onBack={() => navigate('/admin/financeProducts')}
            title={t('financeProductDetails:addTitle')}
        >
            <Form id="financeProductForm" name="financeProductForm" onSubmitCapture={handleSubmit}>
                <FormAutoTouch />
                <FinanceProductForm activeTab={activeTab} />
            </Form>
        </ConsolePageWithHeader>
    );
};

export default Inner;
